// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type {
  SubscriptionOperationGetOptionalParams,
  SubscriptionOperationGetResponse,
} from "../models/index.js";

/** Interface representing a SubscriptionOperation. */
export interface SubscriptionOperation {
  /**
   * Get the status of the pending Microsoft.Subscription API operations.
   * @param operationId The operation ID, which can be found from the Location field in the generate
   *                    recommendation response header.
   * @param options The options parameters.
   */
  get(
    operationId: string,
    options?: SubscriptionOperationGetOptionalParams,
  ): Promise<SubscriptionOperationGetResponse>;
}
